import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'

import { NavigationEnd, Router, RouterOutlet } from '@angular/router'

import { filter } from 'rxjs'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { MatIconRegisterService } from './services/mat-icon-register.service'

import { MaintenanceService } from './services/maintenance.service'
import { MaintenanceComponent } from './pages/maintenance/maintenance.component'
import { PageAccessLogService } from './services/page-access-log/page-access-log.service'

@UntilDestroy()
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MaintenanceComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  isMaintenanceMode = false

  constructor(
    private matIconRegisterService: MatIconRegisterService,
    private maintenanceService: MaintenanceService,
    private pageAccessLogService: PageAccessLogService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.matIconRegisterService.register()

    this.maintenanceService.isMaintenanceMode$
      .pipe(untilDestroyed(this))
      .subscribe((isMaintenanceMode) => {
        this.isMaintenanceMode = isMaintenanceMode
      })

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
        untilDestroyed(this),
      )
      .subscribe((event) => {
        const pathOnly = event.urlAfterRedirects.split('?')[0]
        if (this.isUnauthenticatedPath(pathOnly)) return
        this.pageAccessLogService.recordAccess(pathOnly)
      })
  }

  private isUnauthenticatedPath(path: string): boolean {
    return (
      path === '/login' ||
      path.startsWith('/auth/') ||
      path === '/forgot-password'
    )
  }
}
